import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { get } from "lodash";
import { NotificationManager } from "react-notifications";

import PlaceholderImage from "../../sharedComponents/placeholderImage";

const FinalTestimonialPreview = ({ initialValues, imageList, history }) => {
	const [beforeImage, setBeforeImage] = useState(null);
	const [afterImage, setAfterImage] = useState(null);

	useEffect(() => {
		const getPhoto = (type) => {
			const primaryImage = imageList && imageList.filter((item) => item.type === type && item.primary === true);
			return primaryImage && primaryImage.length ? primaryImage[0].photo_m : null;
		};
		setBeforeImage(getPhoto("B"));
		setAfterImage(getPhoto("A"));
	}, [imageList]);

	const handlePublish = () => {
		NotificationManager.success("Testimonial published successfully!", "", 5000);
		history.push("/testimonials");
	};
	return (
		<div className="mt-3 p-4">
			<h4> Final Version Preview (after save) </h4>
			<div className="clearfix">
				<div className="float-right pl-4 pt-2">
					<PlaceholderImage
						src={beforeImage}
						width={150}
						height={200}
						bg="rgba(0,0,0,0.1)"
						color="rgba(0,0,0,0.3)"
						objectFit="cover"
						className="pointer mr-3"
					/>
					<PlaceholderImage
						src={afterImage}
						width={150}
						height={200}
						bg="rgba(0,0,0,0.1)"
						color="rgba(0,0,0,0.3)"
						objectFit="cover"
						className="pointer"
					/>
				</div>
				<div
					className="final-testimonial-text mt-3"
					dangerouslySetInnerHTML={{ __html: initialValues.fulltext_html }}></div>
			</div>
			<div className="d-flex flex-row justify-content-end mt-3">
				<button type="submit" className="btn btn-primary-dark text-uppercase" onClick={() => handlePublish()}>
					PUBLISH
				</button>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	const { Testimonials } = state;
	return {
		imageList: get(Testimonials, "testimonialImageList.results", null),
		initialValues: get(Testimonials, "testimonialDetail", {})
	};
};

export default connect(mapStateToProps)(FinalTestimonialPreview);
